import { Spinner } from "components/Elements/Spinner";
import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";

const variants = {
  primary: "border-none bg-red-600 text-white hover:bg-red-400",
  secondary: "border-none bg-blue-500 text-white hover:bg-blue-400",
  outline: "border border-red-500 text-red-500",
  inverse: "border-none bg-white text-red-400 hover:bg-red-400 hover:text-white",
  danger: "border-none bg-red-600 text-white hover:bg-red-500",
  dark: "border-none bg-gray-100 text-gray-500 hover:bg-gray-500 hover:text-white"
};

const sizes = {
  xs: "py-2 px-4 text-xs",
  sm: "py-4 px-4 text-sm",
  md: "py-4 px-6 text-md",
  lg: "py-4 px-8 text-lg",
};

export const Button = React.forwardRef(
  (
    {
      type = "button",
      className = "",
      variant = "primary",
      size = "md",
      isLoading = false,
      startIcon,
      endIcon,
      ...props
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        className={clsx(
          "flex justify-center items-center  disabled:opacity-70 disabled:cursor-not-allowed rounded-md shadow-sm font-medium focus:outline-none",
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      >
        {isLoading && <Spinner size="sm" className="text-current" />}
        {!isLoading && startIcon}
        <span className="mx-2">{props.children}</span> {!isLoading && endIcon}
      </button>
    );
  }
);

Button.displayName = "Button";

Button.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.oneOf(["primary", "inverse", "danger"]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  isLoading: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
};
